module.exports = __webpack_public_path__ + "static/media/otras-areas-grande.b40d25d3.jpg";